import request from '@/utils/request'

export function queryEvBikes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/evBike.queryEvBikes',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '查询电动车失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function saveEvBike(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/evBike.saveEvBike',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存电动车失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateEvBike(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/evBike.updateEvBike',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '修改电动车失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 发卡（下发/重新下发）
export function issueEvBike(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/evBike.issueCard',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '发卡失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteEvBike(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/evBike.deleteEvBike',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除电动车失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function auditEvBike(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/evBike.auditEvBike',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核电动车失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
